export const TICK_RATE = 500;
export const GAME_TIME_DURATION = 10;
export const TIME_PROGRESS_MAX = 100;
export const TIME_PROGRESS_DEC = TIME_PROGRESS_MAX / GAME_TIME_DURATION;
